var map = {
	"./apple.svg": 87854,
	"./arrow.svg": 31449,
	"./blockquote.svg": 67343,
	"./calender-icon.svg": 84934,
	"./close.svg": 70862,
	"./crown.svg": 78243,
	"./edit.svg": 67654,
	"./facebook.svg": 43254,
	"./follow-facebook.svg": 85338,
	"./follow-instagram.svg": 35566,
	"./follow-x.svg": 36530,
	"./follow-youtube.svg": 68301,
	"./gears.svg": 76594,
	"./google.svg": 4087,
	"./grid.svg": 58666,
	"./hamburger.svg": 20795,
	"./highlights.svg": 56345,
	"./image-icon.svg": 20285,
	"./image.svg": 41113,
	"./left-arrow.svg": 7445,
	"./linkedin.svg": 3380,
	"./list.svg": 95742,
	"./loading.svg": 39702,
	"./login.svg": 95089,
	"./logo.svg": 9155,
	"./phone.svg": 79746,
	"./play-solid.svg": 19910,
	"./profile.svg": 58425,
	"./read-more-arrow.svg": 33992,
	"./right-arrow-two.svg": 79365,
	"./right-arrow.svg": 65208,
	"./search.svg": 84626,
	"./share.svg": 26711,
	"./simple-arrow.svg": 24616,
	"./solid-arrow-down.svg": 35708,
	"./story-play.svg": 47780,
	"./success-circle.svg": 91352,
	"./summary.svg": 52526,
	"./user-icon.svg": 34487,
	"./user.svg": 18595,
	"./visual-story.svg": 7166,
	"./web-story.svg": 61860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61139;